module.exports = __webpack_public_path__ + "img/ali_pay_price_tip.ea22d209.png";